<template>
  <div>
    <span class="text-uppercase font-weight-light">
      {{ webenvLabel }}
    </span>
    <span class="text-uppercase font-weight-bold">
      {{ currentCustomerName | placeholder('Dashboard') }}
    </span>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers.js'
import utils from '@mixins/utils.js'
export default {
  name: 'AppBarTitle',
  mixins: [utils],
  computed: {
    ...authComputed,
    webenvLabel() {
      const labels = {
        [this.projects.ITALGAS]: 'PORTALE SELFCARE',
        [this.projects.ENI]: 'PORTALE SELFCARE',
        [this.projects.TIM]: 'TIM',
        [this.projects.TUTTOSMART]: 'TUTTO SMART',
        [this.projects.CWM]: 'CLOUD WORKPLACE',
        [this.projects.KNOX]: 'KNOX SERVICES',
      }
      return labels[this.webenv] || this.webenv
    },
  },
}
</script>
